import Swiper, { Navigation, Pagination, Thumbs, Scrollbar } from "swiper";
import { BREAKPOINTS } from "@styles/breakpoints";
import { emitVideoPauseEvent } from "@components/video-thumbs/video-thumbs.js";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/scrollbar";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Thumbs, Scrollbar]);

export default class VideoPlaylist {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".video-playlist");
		this.swiperTopEl = this.el.querySelector(
			".video-playlist__gallery-top"
		);
		this.swiperThumbsEl = this.el.querySelector(
			".video-playlist__gallery-thumbs"
		);
		this.init();
	}

	init() {
		this.setSwiper();
	}

	setSwiper() {
		const swiperScrollbarEl = this.el.querySelector(
			".video-playlist__swiper-scrollbar"
		);
		const swiperNavigationNextEl = this.el.querySelector(
			".video-playlist__swiper-button-next"
		);
		const swiperNavigationPrevEl = this.el.querySelector(
			".video-playlist__swiper-button-prev"
		);
		const swiperPaginationEl = this.el.querySelector(
			".video-playlist__swiper-pagination"
		);

		const galleryThumbs = new Swiper(this.swiperThumbsEl, {
			slidesPerView: "auto",
			spaceBetween: 25,
			breakpoints: {
				[BREAKPOINTS.sm]: {
					slidesPerView: "auto",
					spaceBetween: 25,
				},
				[BREAKPOINTS.md]: {
					slidesPerView: 2,
					spaceBetween: 25,
				},
				[BREAKPOINTS.lg]: {
					slidesPerView: 2,
					spaceBetween: 25,
				},
				[BREAKPOINTS.xl]: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
			effect: "fade",
			keyboard: {
				enabled: true,
			},
			grabCursor: true,
			scrollbar: {
				el: swiperScrollbarEl,
				draggable: true,
				hide: false,
			},
		});

		const galleryTop = new Swiper(this.swiperTopEl, {
			grabCursor: true,
			slidesPerView: 1,
			spaceBetween: 10,
			navigation: {
				nextEl: swiperNavigationNextEl,
				prevEl: swiperNavigationPrevEl,
			},
			thumbs: {
				swiper: galleryThumbs,
			},
			pagination: {
				el: swiperPaginationEl,
				type: "fraction",
			},
		});

		galleryTop.on("slideChange", (swiper) => {
			const previousSlideEl = swiper.slides[swiper.previousIndex];
			emitVideoPauseEvent(previousSlideEl);
		});
	}
}
